import { Component, inject, signal } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { firstValueFrom } from 'rxjs';
import { LoginUsersClient } from '../../shared/model/fss.api';
import { LoaderService } from '../../shared/components/loader/loader.service';
import { LocationService } from '../../shared/services/location.service';
import { FieldComponent } from '../../shared/ui/field/field';
import { EmailInputComponent } from '../../shared/components/email-input/email-input';
import { FormControlPipe } from '../../shared/pipes/form-control.pipe';
import { ButtonComponent, ButtonSize } from '../../shared/ui/button/button';
import { Lock03 } from '../../shared/icons/lock-03/lock-03';
import { Mail01 } from '../../shared/icons/mail-01/mail-01';

@Component({
  standalone: true,
  selector: 'app-forgot-password',
  imports: [
    ReactiveFormsModule,
    FieldComponent,
    EmailInputComponent,
    FormControlPipe,
    ButtonComponent,
    Lock03,
    Mail01,
  ],
  templateUrl: './forgot-password.html',
  styleUrl: './forgot-password.scss',
})
export class ForgotPassword {
  private readonly _fb = inject(FormBuilder);
  private readonly _client = inject(LoginUsersClient);
  private readonly _loader = inject(LoaderService);
  public readonly location = inject(LocationService);

  currentYear = new Date().getFullYear();
  isSent = signal(false);

  form: FormGroup = this._fb.group({
    email: new FormControl('', {
      nonNullable: true,
      validators: [Validators.required, Validators.email],
    }),
  });

  submit() {
    if (!this.form.valid) {
      this.form.markAllAsTouched();
      return;
    }
    this._send();
  }

  resend() {
    this._send();
  }

  private async _send() {
    this._loader.setLoadingText = 'Slanje emaila...';
    this._loader.setShowLoader = true;
    await firstValueFrom(this._client.sendResetPasswordEmail(this.form.value.email));
    this.isSent.set(true);
  }

  protected readonly ButtonSize = ButtonSize;
}
